import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'; // 引入刚刚创建的 router
import dataV from '@jiaminghi/data-view'
import * as echarts from 'echarts';
import { BarChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent
} from 'echarts/components';
// 标签自动布局、全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';
import { LineChart } from 'echarts/charts';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LineChart, // ✅ 加上它！
  BarChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer
]);

// 设置后端基础地址（例如本地接口）
axios.defaults.baseURL = 'https://anjat.bolerunjing.cn/An74/api' // 替换为你的后端地址

// 请求携带 cookie（如果需要）
axios.defaults.withCredentials = true

// 添加到 Vue 原型上
Vue.prototype.$axios = axios

Vue.use(dataV)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
